export default __webpack_public_path__ + "static/media/Background_00270.ce96eac2.png";